const tr = {
  // Navbar
  nav: {
    services: "Hizmetler",
    projects: "Projeler",
    about: "Hakkımızda",
    contact: "İletişim",
    getInTouch: "İletişime Geç",
  },
  
  // Hero
  hero: {
    badge: "BMS",
    title1: "Geleceğin",
    title2: "Zeka Seviyesi",
    subtitle: "Akıllı sistemler, gerçek çözümler.",
    cta1: "Proje Başlat",
    cta2: "Biz Kimiz?",
    scroll: "Keşfet",
  },
  
  // Brand Statements
  brand: {
    s1: "Zeka odaklı mimari",
    s2: "Kurumsal seviye sistemler",
    s3: "Güvenlik & performans öncelikli",
    s4: "Geleceğe hazır yazılım",
  },
  
  // Services
  services: {
    title: "Hizmetlerimiz",
    subtitle: "İhtiyacınıza özel, yüksek performanslı çözümler",
    detailBtn: "Detaylı Bilgi",
    allServices: "Tüm Hizmetler",
  },
  
  // Process
  process: {
    title: "Nasıl",
    titleHighlight: "Çalışıyoruz?",
    subtitle: "Başarılı projeler için kanıtlanmış sürecimiz",
    steps: [
      { number: "01", title: "Analiz & Keşif", desc: "İhtiyaçlarınızı derinlemesine anlıyoruz" },
      { number: "02", title: "Mimari Tasarım", desc: "Ölçeklenebilir sistem mimarisi kuruyoruz" },
      { number: "03", title: "Geliştirme", desc: "Agile metodoloji ile kodluyoruz" },
      { number: "04", title: "Test & Güvenlik", desc: "Kapsamlı test ve güvenlik denetimi" },
      { number: "05", title: "Canlıya Alma", desc: "Kesintisiz deployment süreci" },
      { number: "06", title: "Sürekli Destek", desc: "7/24 teknik destek ve bakım" },
    ],
  },
  
  // Why BMS
  why: {
    title: "Neden",
    titleHighlight: "BrightMind Software?",
    subtitle: "Biz sadece yazılım geliştirmiyoruz. İşinizi geleceğe taşıyacak sistemler kuruyoruz.",
    reasons: [
      "Kod yazmayız, sistem kurarız.",
      "Hazır çözümler değil, doğru mimari.",
      "Uzun vadeli teknoloji ortağınız.",
      "Performans, güvenlik, sürdürülebilirlik.",
    ],
  },
  
  // Tech Stack
  tech: {
    title: "Teknoloji Stack",
    subtitle: "Modern teknolojiler ile geleceğe hazır sistemler",
  },
  
  // Projects
  projects: {
    title: "Projelerimiz",
    subtitle: "Başarıyla tamamladığımız projelerden örnekler",
    viewDetails: "Detayları Gör",
    noProjects: "Henüz proje eklenmemiş.",
    allProjects: "Tüm Projeler",
    comingSoonTitle: "Çok Yakında Projelerimiz Sizlerle!",
    comingSoonMessage: "Ekibimiz şu anda heyecan verici projeler üzerinde çalışıyor. En yeni ve etkileyici çalışmalarımızı burada sizlerle paylaşacağız.",
    comingSoonBadge: "Aktif olarak geliştirme aşamasında",
    contactUs: "Projenizi Konuşalım",
  },
  
  // CTA
  cta: {
    title1: "Fikriniz varsa,",
    title2: "biz onu güçlü bir sisteme dönüştürürüz.",
    subtitle: "Hayalinizdeki projeyi konuşmak için hazırız. Birlikte güçlü sistemler kuralım.",
    btn1: "Projenizi Konuşalım",
    btn2: "İletişime Geç",
  },
  
  // Footer
  footer: {
    company: "BrightMind Software",
    rights: "© 2024 BrightMind Software. Tüm hakları saklıdır.",
    tagline: "BrightMind Software – The Next Level of Intelligence",
  },
  
  // Pages
  pages: {
    backToHome: "Ana Sayfaya Dön",
    loading: "Yükleniyor...",
  },
  
  // Contact Form
  contact: {
    name: "Adınız",
    email: "E-posta",
    message: "Mesajınız",
    send: "Gönder",
    success: "Mesajınız başarıyla gönderildi!",
  },
};

export default tr;
